<template>
  <div class="my-6 flex min-h-10 flex-row items-center justify-between">
    <h2 class="flex items-center text-headline-m">
      <Component
        :is="BackComponent"
        v-if="hasBackTo"
        data-testid="btn-back"
        class="btn-outline-neutral-s mr-2 h-8 w-8 min-w-0 rounded-sm border-0"
        :to="hasBackEvent ? undefined : backTo"
        @click="$emit('back')"
      >
        <ChevronLeftIcon class="lucide-icon-sm" />
      </Component>
      <slot />
    </h2>
    <div>
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronLeftIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed, getCurrentInstance } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  backTo?: RouteLocationRaw
}>()

defineEmits(['back'])

const hasBackEvent = computed(() => {
  return getCurrentInstance()?.vnode?.props?.onBack
})

const hasBackTo = computed(() => {
  return !!(hasBackEvent.value || props.backTo)
})

const BackComponent = computed(() => {
  if (hasBackEvent.value) {
    return 'button'
  }
  return 'RouterLink'
})
</script>
